export class IntersectionObserverHelper {
    constructor(element, options = { threshold: 0 }, callback) {
        this.element = element;
        this.options = options;
        this.callback = callback;
        this.intersecting = false;
    }
    /**
     * Initialize the IntersectionObserver
     */
    observe() {
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        if (!this.observer) {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    this.intersecting = entry.isIntersecting;
                    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
                    if (this.callback) {
                        this.callback(entry);
                    }
                });
            }, this.options);
        }
        this.observer.observe(this.element);
    }
    /**
     * Stop observing and disconnect the observer
     */
    disconnect() {
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        if (this.observer) {
            this.observer.disconnect();
            this.observer = undefined;
        }
    }
    /**
     * Check if the element is currently intersecting
     */
    isIntersecting() {
        return this.intersecting;
    }
}
//# sourceMappingURL=IntersectionObserver.helper.js.map
